import "../../App.css";

function Contact() {


    return (
        <div className="container-lg mt-2">
            <h4 className="writed-text fw-medium fs-1 mb-0 mt-4 ms-2 mb-2">Üdvözöllek!</h4>

            <div className="d-flex flex-column flex-sm-row align-items-center justify-content-center contactDiv">
                <p className="text-justify rounded-start col-sm-6 col-12 m-0 px-4 py-md-4 py-2 contactDiv" style={{backgroundColor: '#afe2ee'}}>Andrea vagyok, a kézművesség mindig is az életem része volt. Gyerekkorom óta imádok alkotni, színekkel, formákkal és anyagokkal kísérletezni.
                </p>
                <img alt="about-img" className="img-fluid rounded col-9 col-sm-4" style={{maxHeight: '200px'}} src="/diy.webp"/>
            </div>
            <hr/>

            <div className="d-flex flex-column align-items-center justify-content-center">
                <p className="text-center px-3">Nyolc éve kezdtem komolyabban foglalkozni a kreatív dekorációk készítésével, hét éve indítottam el Facebook-oldalamat, ahol megosztom a munkáimat. Azóta számtalan asztaldísz, kopogtató, virágbox és egyéb dekorációs elem került ki a kezeim közül. Mind egyedi, szeretettel és gondos odafigyeléssel készült alkotás.</p>
                <div className="d-flex justify-content-around align-items-center">
                    <img alt="about-img" className="img-fluid rounded col-3" src="/about1.webp" />
                    <img alt="about-img" className="img-fluid rounded col-3" src="/about3.webp" />
                    <img alt="about-img" className="img-fluid rounded col-3" src="/about2.webp" />
                </div>
            </div>

            <hr/>
            
            <div className="d-flex flex-column flex-sm-row align-items-center justify-content-around pt-2">
                <p className="fs-5 text-center text-sm-start col-sm-5 m-0 mb-2">"Számomra a kézműves tárgyak nem csupán díszek. Azon dolgozom, hogy az általam készített dekorációk életre keljenek."
                </p>
                <p className="text-justify m-0 mb-2 col-sm-5">Mosolyt fakasszanak, boldogságot és melegséget hozzanak az otthonokba. Hiszem, hogy egy gondosan elkészített kézműves alkotás sokkal több egy tárgynál: emlékeket idézhet fel, meghittséget sugározhat, és örömöt okozhat annak, aki kapja vagy aki ránéz.</p>
                
            </div>

            <hr/>

            <div className="d-flex flex-column flex-sm-row align-items-center justify-content-around">
                <p className="text-justify col-sm-8 col-12 m-0 px-4 py-2">Minden egyes díszben benne van a lelkesedésem, a szeretetem és az a vágyam, hogy valami különlegeset adjak azoknak, akik hozzám fordulnak. Ha egyedi elképzelésed van, vagy valami igazán személyes, egyedi alkotást szeretnél, örömmel megvalósítom az álmodat.
                </p>
                <img style={{maxWidth: '200px'}} alt="about-img" className="img-fluid rounded col-md-3 col-9 col-sm-4" src="/heart.webp"/>
            </div>

            <div className="d-flex flex-column justify-content-center align-items-center">
            <h6 className="ms-2 text-center mt-3">Keress bizalommal, és alkossunk együtt valami csodálatosat!</h6>

            <div className="col-10 col-md-7 mb-3 ms-2 mt-2 d-flex flex-column justify-content-center align-items-center">
                <table className="mb-2">
                    <tbody>
                        <tr>
                            <td>Email:</td>
                            <td className="ps-2">kreativoromok@gmail.com</td>
                        </tr>
                        <tr>
                            <td>Cím:</td>
                            <td className="ps-2">7800 Nagytótfalu, Rákóczi u. 14/c</td>
                        </tr>
                    </tbody>
                    </table>
                    <div className="w-100 d-flex flex-row justify-content-around align-items-center">

                        <a href="https://www.facebook.com/profile.php?id=100057441498402" target="_blank" rel="noopener noreferrer">
                            <i className="bi bi-facebook me-1"></i>Facebook oldalam
                        </a>

                        <a href="https://www.instagram.com/kreativoromok/" target="_blank" rel="noopener noreferrer">
                            <i className="bi bi-instagram me-1"></i>Instagram oldalam
                        </a>

                    </div>
                </div>
            </div>
        </div>

    );
}

export default Contact;